import React from 'react'
import {Icon} from 'semantic-ui-react'

const successMessage = <div style={{color: 'rgb(89,182,85)'}}><b>Saved <Icon name='check'/></b></div>

export {successMessage}
